// extracted by mini-css-extract-plugin
module.exports = {"reference":"Link_reference__QBWIC"};